<div class="crooked-card-header">
    <h2 mat-dialog-title>{{ data.title }}</h2>
</div>
<mat-dialog-content>
    <p [innerHTML]="data.message" class="simple-dialog-message"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if (data.cancel) {
        <button (click)="submit(false)" mat-button type="button">{{ data.cancel }}</button>
    }
    <button (click)="submit(true)" mat-flat-button type="button">{{ data.ok }}</button>
</mat-dialog-actions>
